import { InjectionToken } from '@angular/core'
import { Address, Converter } from '@spartacus/core'

export const MB_CHECKOUT_BILLING_INFO_MODEL_NORMALIZER = new InjectionToken<Converter<any, Address[]>>('MbCheckoutBillingInfoModelNormalizer')
